import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=daf23156&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Support.vue?vue&type=style&index=1&id=daf23156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf23156",
  null
  
)

export default component.exports